import { Api, ApiConfig } from '@shared/api';

const defaultState = {
  currentStep: 0,
  newPasswordSubmiting: false,
  stepData: [
    {
      title: 'Set Password',
    },
    {
      title: 'Complete',
    },
  ],
};
export default {
  name: 'setPassword',
  state: defaultState,
  reducers: {
    updateState(state: any, payload: any) {
      return {
        ...state,
        ...payload,
      };
    },
    resetState() {
      return defaultState;
    },
  },
  effects: (dispatch: any) => ({
    async passwordUpdate(pwd: string) {
      dispatch.setPassword.updateState({
        newPasswordSubmiting: true,
      });
      try {
        await Api.request(ApiConfig.updatePassword, {
          password: pwd,
        });
        dispatch.setPassword.updateState({
          currentStep: 1,
        });
      } catch (e) {
        return e;
      } finally {
        dispatch.setPassword.updateState({
          newPasswordSubmiting: false,
        });
      }
    },
  }),
};
